import { useSearchParams } from "react-router-dom";
import Layout from "../../components/Layout";
import Roster from "./Roster";
import Payables from "./Payables";

const TABS = [
  ["roster", "Roster", "/more/crew"],
  ["payables", "Payables", "/more/crew?tab=payables"],
];

export default function Crew() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "payables" ? "payables" : "roster";
  return (
    <Layout title="Crew">
      <div className="mb-4 flex gap-2" data-testid="crew-tabs">
        {TABS.map(([k, label, to]) => (
          <button key={k} data-testid={`crew-tab-${k}`} onClick={() => setParams(k === "roster" ? {} : { tab: k })}
            className={`h-11 flex-1 rounded-md border text-sm font-bold transition-colors ${tab === k ? "border-primary bg-primary text-primary-foreground" : "border-border"}`}>
            {label}
          </button>
        ))}
      </div>
      {tab === "roster" ? <Roster embedded /> : <Payables embedded />}
    </Layout>
  );
}
